<template>
<div class="modal fade" id="modalChangeTotalEmployee" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Alteração do total de funcionário maximo.</h4>
      </div>

      <div class="modal-body">
        <form>
          <div class="form-group">
            <label>Total</label>
            <input v-model="total" type="text" class="form-control" name="email" placeholder="Total" required>
            <span v-if="errorMsgTotal" class="error-msg">{{ errorMsgTotal }}</span>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button v-on:click="changeTtl()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
          <span v-if="!loadingChange">Salvar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  UPDATE_COMPANY_TOTAL
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../utils";

export default {
  name: "modalChangeTotalEmployee",
  props: ['dataCompanyModal'],
  data() {
    return {
      modalContext: '',
      errorMsgTotal: '',
      total: '',
      companyValue: '',
      successChangeTotal: '',
      loadingChange: false
    }
  },
  watch: {
    dataCompanyModal: function (val) {
      this.companyValue = val;
      this.modalContext = val.context;
    },
    successChangeTotal: function (val) {
      this.$emit('update:newTotalEmployee', val)
    },
  },
  methods: {
    closeModal() {
      $('#modalChangeTotalEmployee').modal('toggle');
    },
    changeTtl() {
      this.errorMsgTotal = "";
      if (this.total && this.companyValue.idCompany) {

        let url = UPDATE_COMPANY_TOTAL;
        url += "?i=" + this.companyValue.idCompany;
        url += "&totalPlanEmployee=" + this.total;

        UTIL_SERVICE.console("DATA SEND:", url);
        REQUEST_SERVICE.requestContext('GET', url, this.modalContext).then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_FINANCIAL_EMAIL:", response);

          this.successChangeTotal = this.total;

          $('#modalChangeTotalEmployee').modal('toggle');

          swal("Aviso", "Empresa atualizada com sucesso.", "success");

        }).catch((reason) => {
          $('#modalChangeTotalEmployee').modal('toggle');

          swal("Aviso", "Contate nosso suporte.", "error");
        });
      } else {
        this.errorMsgTotal = "Preencha um valor válido.";
      }
    }
  }
}
</script>

<style lang="scss">
#modalChangeTotalEmployee {
  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeTotalEmployee.vue